const setLeadsContent = (state, action) => action.leadsContent || state;

export default setLeadsContent;
